import React from "react";
import { STAGE_STYLES } from "@/lib/apiClient";

export default function StatusBadge({ status, size = "sm" }) {
    const s = STAGE_STYLES[status] || STAGE_STYLES.closed;
    const padding = size === "lg" ? "px-3 py-1.5" : "px-2.5 py-1";
    const text = size === "lg" ? "text-xs" : "text-[11px]";
    return (
        <span
            data-testid={`status-badge-${status}`}
            className={`inline-flex items-center ${padding} ${text} font-mono uppercase tracking-wider`}
            style={{
                backgroundColor: s.bg,
                color: s.text,
                border: `1px solid ${s.border}`,
            }}
        >
            {status?.replace(/_/g, " ")}
        </span>
    );
}
